<template lang="html">
  <main>
    <div class="roller"></div>
    <section>
      <div class="title">
        Newsletter
      </div>
    </section>
    <form
      class="js-cm-form"
      id="subForm"
      action="https://www.createsend.com/t/subscribeerror?description="
      method="post"
      data-id="A61C50BEC994754B1D79C5819EC1255C6C447B5E14E20C7F497ADB45FE1C33D7DFCEA65FF4C0FAB235696DE1695E9C574024C8DFE6174FE421C31CEFDF53A4BB"
    >
      <section v-if="!complete">
        <div class="title f-w">
          <input
            autocomplete="Email"
            aria-label="Email"
            class="js-cm-email-input"
            placeholder="Email..."
            id="fieldEmail"
            maxlength="200"
            name="cm-nuull-nuull"
            required=""
            type="email"
          />
        </div>
      </section>
      <section v-if="!complete">
        <div class="title">
          <button type="submit" class="so-button">&rarr; Subscribe</button>
        </div>
      </section>
    </form>
    <section v-if="complete">
      <div class="title">
        Thank you
      </div>
    </section>
  </main>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "– Newsletter"
    };
  }
};
</script>

<style lang="scss" scoped>
.f-w {
  width: 100% !important;
  padding-right: var(--lh) !important;
}
.error {
  font-family: "Kolektiv-Light", serif !important;
  text-transform: none;
  font-size: var(--fs);
  color: rgb(255, 0, 0);
}
input[type="email"],
button.so-button {
  font-family: "SORepresent-Light", serif !important;
  text-transform: uppercase;
  width: 100%;
  font-size: calc(4 * var(--fs));
  appearance: none;
  border: 0;
  padding: 0;
  margin: 0;
  background: white;
  outline: none;
  color: #000;
  transition: color 0.5s;
  &:required {
    box-shadow: none;
  }
  &:invalid {
    color: red;
    &:focus {
      color: black;
    }
  }
  &::placeholder {
    color: rgba(0, 0, 0, 0.3);
  }
  @media only screen and (max-width: 768px) {
    font-size: calc(2 * var(--fs));
  }
}
button.so-button {
  color: rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: color 0.5s;
  &:hover {
    color: #000;
  }
}
</style>
